import { useGetStaticAssetUrl } from '@change-corgi/core/react/assets';
import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { usePolicyPageData } from 'src/app/pages/legal/policy/pageContext';
import { getHeroImageUrl, getTitle, isUpdateDateVisible } from 'src/app/pages/legal/policy/shared/utils';

type Result = ModelHookResult<{
	pageTitle: string;
	updatedAt: string | undefined;
	heroImageUrl: string;
}>;

export function usePageHeading(): Result {
	const {
		data: { slug, updatedAtLocalized },
	} = usePolicyPageData();
	const utilityContext = useUtilityContext();
	const getStaticAssetUrl = useGetStaticAssetUrl();

	return {
		data: {
			pageTitle: getTitle(utilityContext, slug),
			updatedAt: isUpdateDateVisible(slug) ? updatedAtLocalized : undefined,
			heroImageUrl: getStaticAssetUrl(getHeroImageUrl(slug)),
		},
	};
}
